//
// Copyright (c) 2011-2020 by Curalate, Inc.
//

export class CollectionsSettingsService {
  private tenantedCollectionId?: string;

  public getTenantedCollectionId() {
    return this.tenantedCollectionId;
  }

  public setTenantedCollectionId(id: string) {
    this.tenantedCollectionId = id;
  }
}

angular.module('curalate').service('CollectionsSettingsService', [
  CollectionsSettingsService,
]);
